import { uri } from '../../api-endpoint';
import { IAnnotationAPIValidationError } from '../../type-conversion/annotation/from-api-repsonse';
import { IImageInfoFromAPISuccessResponse } from '../../type-conversion/image-info/from-api-repsonse';
import { ImageInfoAPIRequestBodyPartial } from '../../type-conversion/image-info/to-api-request-body';
import { updatePartiallyTemplateFn } from '../common';

export const updateModelImagePartially = (token: string) => (
  modelId: number,
  imageId: number
) =>
  updatePartiallyTemplateFn(
    token,
    uri.modelImageById(modelId, imageId),
    ImageInfoAPIRequestBodyPartial,
    IImageInfoFromAPISuccessResponse,
    IAnnotationAPIValidationError
  );
